import { getSizeToken } from '@koaly/mixins';
import styled, { css } from 'styled-components';

const placements = {
    'top-left': css `
    top: 0;
    left: 0;
  `,
    'top-center': css `
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  `,
    'top-right': css `
    top: 0;
    right: 0;
  `,
    'bottom-left': css `
    bottom: 0;
    left: 0;
  `,
    'bottom-center': css `
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  `,
    'bottom-right': css `
    bottom: 0;
    right: 0;
  `,
};
const ToastContainer = styled.div `
  box-sizing: border-box;
  max-height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  padding: ${getSizeToken('toast', 'gutter')};
  pointer-events: ${({ hasToasts }) => hasToasts ? null : 'none'};
  position: fixed;
  z-index: 300;
  ${({ placement }) => placements[placement]};
`;

export { ToastContainer };
//# sourceMappingURL=ToastContainer.js.map
